import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["write", "preview", "content", "writeTab", "previewTab", "empty"]

  showWrite() {
    this.writeTarget.classList.remove("hidden")
    this.previewTarget.classList.add("hidden")
    this.setActiveTab(this.writeTabTarget, this.previewTabTarget)
  }

  showPreview() {
    const editor = this.element.querySelector("trix-editor")
    const html = editor?.inputElement?.value || ""
    const safeHtml = this.sanitize(html)

    if (safeHtml.trim()) {
      this.contentTarget.innerHTML = safeHtml
      this.contentTarget.classList.remove("hidden")
      this.emptyTarget.classList.add("hidden")
    } else {
      this.contentTarget.replaceChildren()
      this.contentTarget.classList.add("hidden")
      this.emptyTarget.classList.remove("hidden")
    }

    this.writeTarget.classList.add("hidden")
    this.previewTarget.classList.remove("hidden")
    this.setActiveTab(this.previewTabTarget, this.writeTabTarget)
  }

  sanitize(html) {
    const document = new DOMParser().parseFromString(html, "text/html")
    document.querySelectorAll("script, style, iframe, object, embed").forEach((node) => node.remove())
    document.querySelectorAll("*").forEach((node) => {
      Array.from(node.attributes).forEach((attribute) => {
        const value = attribute.value.trim().toLowerCase()
        if (attribute.name.toLowerCase().startsWith("on") || value.startsWith("javascript:")) {
          node.removeAttribute(attribute.name)
        }
      })
    })
    return document.body.innerHTML
  }

  setActiveTab(active, inactive) {
    active.dataset.active = "true"
    inactive.dataset.active = "false"
  }
}
